import gql from "graphql-tag";

export const SIGN_OUT = gql`
  mutation($oneSignalId: String) {
    signout(input: { onesignal_id: $oneSignalId })
  }
`
